var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Layout"},[_c('header',[_c('HeaderNav')],1),_c('main',[_c('router-view')],1),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }